<template>
	<div class="display-flex flex-justify-space-between on-boarding-step-wrapper">
		<div class="display-flex flex-column flex-justify-space-between">
			<div class="on-boarding-step-explanation-text">
				<div>Welcome 👋</div>
				<div>A few notes:</div>
				<div>1. We're a new platform, and some product areas are still in development</div>
				<div>2. Help us improve by providing feedback via chat or the community</div>
				<div>3. Expect frequent updates and upgrades</div>
			</div>
			<div class="display-flex flex-row flex-align-center">
				<AnemicButton :disabled="isCompleted" @click="openVideoDialog" tile class="on-boarding-step-finish-step-button">
					Let's go
				</AnemicButton>
				<div v-if="!isCompleted" @click="markAsComplete" class="ml-6 mark-done on-boarding-step-explanation-text">Mark as done</div>
			</div>
		</div>
		<div class="iframe-container">
			<div v-if="isLoading" class="width-100 height-100 flex-centerize">
				<AppLoader size="18px" />
			</div>
			<div class="width-100" style="position: relative; padding-bottom: 56.25%; height: 0">
				<iframe
					frameborder="0"
					allowfullscreen
					:src="VIDEO_URL"
					mozallowfullscreen
					v-show="!isLoading"
					webkitallowfullscreen
					@load="isLoading = false"
					class="iframe-container rounded"
					style="top: 0; left: 0; width: 100%; height: 100%; position: absolute"
				/>
				<div @click="openVideoDialog" style="top: 0; left: 0; width: 100%; height: 100%; position: absolute" />
			</div>
		</div>
	</div>
</template>

<script>
const VIDEO_URL = 'https://www.loom.com/embed/c0a0a4e3050e4a6ab9b7bee978e9efba';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
export default {
	name: 'OnBoardingWelcomeToPlyStep',
	props: { stepDetails: { type: Object } },
	components: {},
	computed: {
		isCompleted() {
			return this.stepDetails.isCompleted;
		},
	},
	methods: {
		markAsComplete() {
			this.$emit('mark-step-as-done', this.stepDetails);
		},
		openVideoDialog() {
			this.markAsComplete();
			AppDialogManagerService.openIFrameDialog({ iframeUrl: this.VIDEO_URL });
		},
	},
	created() {},
	data() {
		return {
			VIDEO_URL,
			isLoading: true,
		};
	},
};
</script>

<style scoped lang="scss">
.iframe-container {
	height: 244px;
	overflow: hidden;
	border-radius: 16px;
	width: 430px !important;
	border: 1px solid #dfe4ef;
}
.mark-done {
	cursor: pointer;
	text-decoration: underline;
}
</style>
